<tt-page class="flex-column height-full" ttClass="flex-column height-full">
    <tt-page-heading ttModel="p2_m_myactivities" [ttTranslate]="true"></tt-page-heading>
    <tt-grid class="col-xs-12 sp-0 flex-1 height-full" *ngIf="!!grid" [ttOptions]="grid"></tt-grid>
</tt-page>
